import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Layout,
  Menu,
  Icon,
  Modal,
} from 'antd';
import { Link } from 'react-router-dom';

import { Logo } from '../../Page';

import styles from './Sidebar.module.css';

const { Sider } = Layout;
const { SubMenu } = Menu;
const { confirm } = Modal;
const MenuItem = Menu.Item;

const showConfirm = (action) => {
  confirm({
    title: 'Do you want to log out?',
    content: '',
    okText: 'Yes',
    okType: 'primary',
    cancelText: 'No',
    icon: <Icon type="logout" />,
    onOk() {
      action();
    },
  });
};

const handleLogout = (e, logout) => {
  showConfirm(logout);
};

class Sidebar extends Component {
  render() {
    const {
      width,
      logout,
      location,
      breakpoint,
      src,
      alt,
      toggle,
      collapsed,
    } = this.props;
    const path = location.pathname;
    const menu = [
      {
        key: "/reports",
        title: <span><Icon type="dashboard" className={styles['menu-icon']}/>Reports</span>,
        items: [
          { key: "/reports/overview", title: "Overview" },
          { key: "/reports/daily", title: "Daily" },
          { key: "/reports/hourly", title: "Hourly" },
          { key: "/reports/filtered_clicks", title: "Filtered Clicks" },
          { key: "/reports/subID", title: "Sub ID" },
          { key: "/reports/referer", title: "Referer" },
          { key: "/reports/country", title: "Country" },
        ],
      },
      // {
      //   key: "/WD",
      //   title: <span><Icon type="area-chart" className={styles['menu-icon']}/>WD</span>,
      // },
      {
        key: "/feeds",
        title: <span><Icon type="link" className={styles['menu-icon']}/>Feeds</span>,
        items: [
          { key: "/feeds/XML", title: "XML" },
          { key: "/feeds/search", title: "Search" },
        ],
      },
      {
        key: "/payments",
        title: <span><Icon type="dollar" className={styles['menu-icon']}/>Payments</span>,
        items: [
          { key: "/payments/history", title: "History" },
          { key: "/payments/details", title: "Details" },
        ],
      },
      {
        key: "/tickets",
        title: <span><Icon type="bell" className={styles['menu-icon']}/>Tickets</span>,
        items: [
          { key: "/tickets/opened", title: "Opened" },
          { key: "/tickets/closed", title: "Closed" }
        ],
      },
      {
        key: "/profile",
        title: <span><Icon type="setting" className={styles['menu-icon']}/>Profile</span>,
      },
      {
        key: "/logout",
        title: <span><Icon type="logout" className={styles['menu-icon']}/>Logout</span>,
        handler: (e) => handleLogout(e, logout)
      }
    ];

    return (
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        onBreakpoint={() => {
          return false
        }}
        className={styles.sidebar}
        breakpoint={breakpoint}
        collapsedWidth="0"
        width={width}
      >
        <Logo
          src={src}
          alt={alt}
        />
        <Menu
          mode="inline"
          selectedKeys={[path]}
          className={styles['sidebar-menu']}
        >
          {menu.map(({ key, title, items, handler }) =>
            items ? (
              <SubMenu
                key={key}
                title={title}
              >
                {items.map(({ key, title }) => (
                  <MenuItem key={key}>
                    <Link
                      to={key}
                      onClick={toggle}
                    >
                      {title}
                    </Link>
                  </MenuItem>
                ))}
              </SubMenu>
            ) : (
              <MenuItem
                key={key}
                onClick={handler}
              >
                {key === '/logout'
                  ? title : (
                  <Link
                    to={key}
                    onClick={toggle}
                  >
                    {title}
                  </Link>
                )}
              </MenuItem>
            )
          )}
        </Menu>
      </Sider>
    );
  }
}

Sidebar.propTypes = {
  width: PropTypes.number.isRequired,
  logout: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default Sidebar;
